import React from 'react';
import './Copies.scss';
import lady from '../../assets/labcoatLady.jpg';
import { motion } from 'framer-motion';

const Copy2 = () => {
  return (
    <section className="copies" style={{ marginTop: 0 }}>
      <h4 className="copies__title">Understanding Eczema’s Multidimensional Nature</h4>
      <p className="copies__copy">
        Because eczema is such a visible condition—often flaring on areas such as the face, arms,
        and legs—those living with it can often feel self-conscious or isolated. In fact, according
        to a study published by{' '}
        <span style={{ fontStyle: 'italic' }}>The Journal of Allergy and Clinical Immunology</span>,
        43% of adult patients experience concerns about being seen in public while experiencing a
        flare-up.
      </p>
      <p className="copies__copy">
        Los Angeles therapist Elizabeth “Liz” Mack treats people suffering from eczema, but she’s
        able to bring a unique perspective to her patients as a person living with eczema herself.
        She’s had her own struggles with the disease, especially its emotional burdens.
      </p>{' '}
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1, type: 'tween' }}
        className="pullQuote"
      >
        “I internalized the belief that somehow, I was responsible for my own suffering. I thought
        if I just tried hard enough, I could resist scratching; maybe it was in my head.”
      </motion.p>
      <div className="inlinePhoto inlinePhoto--desktop--left">
        <img className="inlinePhoto__image" src={lady} alt="Portrait of Dr. Zakiya Rice" />
        {/* <p className="inlinePhoto__name inlinePhoto--description">Dr. Zakiya Rice</p> */}
        <p className="inlinePhoto__title inlinePhoto--description">
          Dr. Morgana Colombo, Dermatologist{' '}
        </p>
      </div>
      <p className="copies__copy">
        The ties between eczema and emotional health are clear, according to dermatologist Dr.
        Morgana Colombo, with patients being more prone to anxiety and depression associated with
        their disease. “It is important for primary care doctors and dermatologists to be cognizant
        of that,” she says, “and to offer patients tools to better handle these issues and
        appropriately intervene when needed.”
      </p>{' '}
      <p className="copies__copy">
        Eczema is a chronic and recurring inflammatory disease, and for some it may require
        long-term treatment. This can mean a lifelong battle not only to control outbreaks, but also
        to deal with the psychological and emotional impact. Acknowledging the multidimensional
        nature of eczema is the first step in validating the communities living with it.
      </p>{' '}
    </section>
  );
};

export default Copy2;
